import { SET_PEOPLE_COUNTER_DATA, CLEAR_PEOPLE_COUNTER_DATA, SET_PEOPLE_COUNTER_PAGE_NUMBER } from "../types"

const initialState = {
  data: [],
  latestDate: null,
  pageNumber: 1,
}

const peopleCounterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PEOPLE_COUNTER_DATA:
      return {
        ...state,
        data: action.payload.data,
      }
    case SET_PEOPLE_COUNTER_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case CLEAR_PEOPLE_COUNTER_DATA:
      return initialState
    default:
      return state
  }
}

export default peopleCounterReducer